export const rounded = (value, amount, suffix) => {
  if (!value) return '0'
  value = Math.round(value / amount)
  return value > 0 ? value + suffix : '0'
}
